import { OrderDetailTemplate } from "@/components/Templates";
import { useOrderDetailPage } from "@/hooks/useOrderDetailPage";

export function OrderDetailPage() {
  const orderDetail = useOrderDetailPage();

  return <OrderDetailTemplate {...orderDetail} />;
}
